import { onError } from "@apollo/client/link/error";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      if (error.message.indexOf('Premium access required') !== -1) {
        return;
      }
      // eslint-disable-next-line no-console
      console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
    });
  }

  if (networkError) {
    // eslint-disable-next-line no-console
    console.log('%cNetwork error', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', networkError)
  }
});

export default errorLink;